import React, { type ChangeEvent } from "react";
import styles from "./styles.module.css";
import checkBoxStyles from "./checkbox.module.css";
import { getRegExp, getSentenceFromCamelCase } from "./Helpers";

const Checkbox = ({
  checked,
  disabled,
  error,
  fixLength,
  required,
  label,
  minLength,
  maxLength,
  name,
  onChange,
  data,
  reqType,
  validationHandler,
  value,
  size = "medium",
  labelClassName,
  filter,
}: any) => {
  const onChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value: itemValue, checked } = event.target;
    const updatedValues = Array.isArray(value) ? [...value] : [];
    if (checked) {
      if (!updatedValues.includes(itemValue)) {
        updatedValues.push(itemValue);
      }
    } else {
      const index = updatedValues.indexOf(itemValue);
      if (index > -1) {
        updatedValues.splice(index, 1);
      }
    }
    onChange && onChange(name, updatedValues);
  };

  const onValidationChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (!validationHandler) return;
    const { value } = event.target;
    let errorMessage = "";
    if (!value && required) {
      errorMessage = `Please enter ${getSentenceFromCamelCase(name)}.`;
    } else if (minLength && value.length < minLength) {
      errorMessage = `${
        name.charAt(0).toUpperCase() + getSentenceFromCamelCase(name).slice(1)
      } must be at least ${minLength} characters long.`;
    } else if (maxLength && value.length > maxLength) {
      errorMessage = `${
        name.charAt(0).toUpperCase() + getSentenceFromCamelCase(name).slice(1)
      } must be ${minLength} characters long.`;
    } else if (fixLength && value.length !== fixLength) {
      errorMessage = `${
        name.charAt(0).toUpperCase() + getSentenceFromCamelCase(name).slice(1)
      } must be ${fixLength} characters.`;
    } else if (value && reqType && !getRegExp(reqType)?.test(value)) {
      errorMessage = `Please enter valid ${getSentenceFromCamelCase(name)}.`;
    }
    validationHandler(name, errorMessage);
  };
  return (
    <div className={`${styles.radioFlex} ${styles[size]}`}>
      <label htmlFor={name} className={labelClassName}>
        {label}
        {required && <span className={styles.required}>&nbsp;*</span>}
        {error ? (
          <span className={`${styles.required} ${styles.textSmall}`}>
            {error}
          </span>
        ) : null}
      </label>

      <div className={styles.Radiooptions}>
        {data.map((item: any, i: number) => (
          <span className={checkBoxStyles.wrapper}>
            <div className={checkBoxStyles["checkbox-wrapper-44"]}>
              <label className={checkBoxStyles.toggleButton}>
                <input
                  id={name[i]}
                  type="checkbox"
                  onChange={onChangeHandler}
                  value={filter ? item[filter] : item.value}
                  name={name}
                  checked={
                    Array.isArray(value) &&
                    value.includes(filter ? item[filter] : item.value)
                  }
                  required={required}
                  onBlur={onValidationChange}
                  disabled={disabled}
                />
                <div>
                  <svg viewBox="0 0 44 44">
                    <path
                      d="M14,24 L21,31 L39.7428882,11.5937758 C35.2809627,6.53125861 30.0333333,4 24,4 C12.95,4 4,12.95 4,24 C4,35.05 12.95,44 24,44 C35.05,44 44,35.05 44,24 C44,19.3 42.5809627,15.1645919 39.7428882,11.5937758"
                      transform="translate(-2.000000, -2.000000)"
                    ></path>
                  </svg>
                </div>
              </label>
            </div>
            {filter ? item[filter] : item.value}
          </span>
        ))}
      </div>
    </div>
  );
};

Checkbox.defaultProps = {
  checked: false,
  className: "",
  disabled: false,
  error: "",
  fixLength: 0,
  required: false,
  label: "",
  minLength: 0,
  maxLength: 0,
  placeholder: "",
  reqType: "",
  style: {},
  type: "checkbox",
  validationHandler: () => {},
  size: "medium",
  labelClassName: styles.labelBlack,
  value: [],
  data: [],
  filter: "",
};

export default Checkbox;
